"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFontScale = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = require("styled-components");

var makeFontScale = function makeFontScale(n, theme) {
  var _a;

  var _b = (0, ui_symbols_1.getFontScale)(n, (_a = theme === null || theme === void 0 ? void 0 : theme.TYPOGRAPHY) === null || _a === void 0 ? void 0 : _a.SCALE),
      size = _b.size,
      lineHeight = _b.lineHeight;

  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), size, lineHeight);
};

exports.makeFontScale = makeFontScale;
var templateObject_1;